import { apiClient } from "./fetch";

export const exportBookingsExcel = async (params: {
  hospitalId: string;
  from: string;
  to: string;
}) => {
  return apiClient.get("/reports/export-bookings", {
    params,
    responseType: "blob",
  });
};
